export default function SetMemberInclusionFlag($http) {
  'ngInject';

  return function (masterPlanId, memberId, sellerId, included) {
    console.warn(
      'The setMemberInclusionFlag service has been deprecated and will be removed from a future release.'
    );

    return $http.post(
      '/aptitude/buyer/GroupImpactServiceController/setInclusionFlag',
      {},
      {
        params: {
          masterPlanId: masterPlanId,
          memberId: memberId,
          sellerId: sellerId,
          included: included
        }
      }
    );
  };
}
